import {
  DEAN_MARKER_REGEX,
  extractEmployeeOrder,
  stripEmployeeMarkers,
  withEmployeeMarkers,
} from "./employeeOrder";

export { DEAN_MARKER_REGEX };

export function extractDeanOfFacultyId(interests = "", deanOfFacultyId = "") {
  if (deanOfFacultyId !== undefined && deanOfFacultyId !== null && deanOfFacultyId !== "") {
    return String(deanOfFacultyId);
  }
  const match = String(interests || "").match(DEAN_MARKER_REGEX);
  return match ? String(match[1]) : "";
}

export function stripDeanMarker(interests = "") {
  return stripEmployeeMarkers(interests);
}

export function withDeanMarker(interests = "", deanOfFacultyId = "", order = null) {
  const currentOrder = order !== null ? order : extractEmployeeOrder(interests);
  return withEmployeeMarkers(interests, deanOfFacultyId, currentOrder);
}
